import { tempRoutes as routes } from '@/expert/router'
import low from 'lowdb'
import LocalStorage from 'lowdb/adapters/LocalStorage'
import { get, set, remove } from '@/utils/auth'
import request from '@/utils/request'
import tabs from './tabs'

const adapter = new LocalStorage(`expert`)
const db = low(adapter)
const firstRouter = routes[0].children[0]
const expert = {
    state: {
        loginUser: {},
        userMenus: [],
        tabRoutes: [{
            meta: firstRouter.meta,
            fullPath: 'test1',
            name: firstRouter.name,
            path: '/' + firstRouter.path,
            params: {},
            query: {}
        }],
        activeName: '/' + firstRouter.path,
        headerActiveName: '',
        pagePool: [],
    },
    mutations: {
        async getPexertInfo (state) {
            if(state.loginUser.pexpertid){
                let res = await request({
                    method: 'get',
                    url: 'expert/getPexertInfo',
                    params: {pexpertid: state.loginUser.pexpertid}
                })
                state.loginUser.pexpertname = res.pexpertname
            }
        },
        async set_expert_user_info(state, data) {
            // state.loginUser = data.user
            // state.loginUser.token = data.token
            // state.userMenus = data.userMenu
            // if (data.userMenu.length > 0) {
            //     tabs.state['headerActiveName'] = data.userMenu[0].path
            // }
            // this.commit('set_to_db')
            state.loginUser = data
            state.loginUser.token = data.token
            
            const res = await request({
                method: 'get',
                url: 'expert/findProjectById',
                params: {projectid: state.loginUser.pexpertprojectid}
            })
            if(+res.projectisqcheck === 2){
                routes[0].children = routes[0].children.filter(e=>{
                    return  e.name != 'exPqcCheckTab' && e.name != 'exPqcCheckSumIndex'
                })
            }

            const TYPE = state.loginUser.pexpertroletype == 2 ? 'common' : 'leader'
            // state.loginUser = {pexpertid: '199',pexpertprojectid: 232,pexpertlogincode: '617924'}
            state.userMenus = routes[0].children.map(item => {
                let _obj = {}
                _obj.title = item.meta.title
                _obj.name = item.name
                _obj.path = item.path
                _obj.role = item.role
                return _obj
            }).filter(item => {

                // if (TYPE == 'common') return item.role != 'leader'
                // else return item
                return item.role === 'common'
            })
            this.commit('set_to_db')
        },
        set_to_db(state) {
            set('expertToken', 'expertWeb')
            db.set(get('expertToken'), {
                loginUser: state['loginUser'],
                userMenus: state['userMenus'],
                tabRoutes: [],
                // headerActiveName: tabs.state['headerActiveName']
            }).write()
        },
        expert_pool_set (state, pool) {
            state.pagePool = pool
        },
        set_expert_active_name(state, data) {
            state.activeName = data
        },
        set_expert_header_active_name(state, data) {
            state.headerActiveName = data
            this.commit('set_expert_header_active_name_to_db')
        },
        set_expert_active_tabs(state, data) {
            state.tabRoutes = data
        },
        open_expert_new_tabs(state, newRoute) {
            if (newRoute.name) {
                if (newRoute.name === 'reportQuery') {
                    let openedtabs = state.tabRoutes
                    let index = openedtabs.findIndex(tab => (tab.name === newRoute.name && Number(tab.query.reportid) === Number(newRoute.query.reportid)))
                    if (index === -1) {
                        state.tabRoutes.push({
                            meta: newRoute.meta,
                            fullPath: newRoute.fullPath,
                            name: newRoute.name,
                            path: newRoute.path,
                            params: newRoute.params,
                            query: newRoute.query
                        })
                        state.activeName = newRoute.name + newRoute.query.reportid
                        this.commit('set_experttabs_to_db')
                    } else {
                        state.activeName = openedtabs[index].name + openedtabs[index].query.reportid
                    }
                } else {
                    let openedtabs = state.tabRoutes
                    let index = openedtabs.findIndex(tab => (tab.name === newRoute.name))
                    if (index === -1) {
                        state.tabRoutes.push({
                            meta: newRoute.meta,
                            fullPath: newRoute.fullPath,
                            name: newRoute.name,
                            path: newRoute.path,
                            params: newRoute.params,
                            query: newRoute.query
                        })
                        state.activeName = newRoute.name
                        this.commit('set_experttabs_to_db')
                    } else {
                        state.activeName = openedtabs[index].name
                    }
                }
            }
        },
        close_expert_tab(state, { routeName, vm, newRouteName }) {
            let openedtabs = state.tabRoutes
            let index
            if (routeName.indexOf('reportQuery') === -1) {
                index = openedtabs.findIndex(tab => (tab.name === routeName))
            } else {
                index = openedtabs.findIndex(tab => (tab.name + tab.query.reportid === routeName))
            }
            openedtabs.splice(index, 1)
            if (newRouteName) {
                let newRoute = openedtabs.find(tab => (tab.name === newRouteName))
                if (newRoute) {
                    this.commit('set_expert_active_name', newRoute.name)
                    vm.$router.push(newRoute)
                } else {
                    let newRoute = openedtabs[openedtabs.length - 1]
                    this.commit('set_expert_active_name', newRoute.name)
                    vm.$router.push(newRoute)
                }
            } else {
                let newRoute = openedtabs[openedtabs.length - 1]
                if (newRoute.name === 'reportQuery') {
                    this.commit('set_expert_active_name', newRoute.name + newRoute.query.reportid)
                } else {
                    this.commit('set_expert_active_name', newRoute.name)
                }
                vm.$router.push(newRoute)
            }
            state.tabRoutes = openedtabs
            this.commit('set_experttabs_to_db')
        },
        set_experttabs_to_db(state) {
            db.get(get('expertToken')).set('tabRoutes', state.tabRoutes).write()
        },
        set_expert_header_active_name_to_db (state) {
            db.get(get('expertToken')).set('headerActiveName',state.headerActiveName).write()
        },
        get_expert_user_from_db () {
            this.commit('get_expert_user_from_db_by_token')
        },
        get_expert_user_from_db_by_token (state) {
            if (db.has(get('expertToken')).value()) {
                let expertWeb = db.get(get('expertToken')).value()
                state['loginUser'] = expertWeb.loginUser
                state['userMenus'] = expertWeb.userMenus
                tabs.state['tabRoutes'] = expertWeb.tabRoutes || []
                tabs.state['headerActiveName'] = expertWeb.headerActiveName || ''
            }
        },
    },
}
export default expert